import GlobalTitle from './GlobalTitle.vue'
export default GlobalTitle
